/**
 * SiteMax Brand Colors
 * Centralized color constants for consistent branding across the application
 */
export const COLORS = {
  // SiteMax Primary Blue
  PRIMARY_BLUE: '#1976d2',

  // SiteMax Primary Blue Hover (darker shade)
  PRIMARY_BLUE_HOVER: '#1565c0',

  // SiteMax Dark Navy (for headers/footers)
  DARK_NAVY: '#08172b',

  // Text Colors
  WHITE: '#ffffff',
  BLACK: '#000000',

  // Neutral Grays
  GRAY_LIGHT: '#f5f5f5',
  GRAY_MEDIUM: '#777777',
  GRAY_DARK: '#333333',
} as const;

// Type for color keys (for TypeScript autocomplete)
export type ColorKey = keyof typeof COLORS;
